import { render, staticRenderFns } from "./SidebarMenuItem.vue?vue&type=template&id=4cf33cbe&scoped=true&"
import script from "./SidebarMenuItem.vue?vue&type=script&lang=js&"
export * from "./SidebarMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./SidebarMenuItem.vue?vue&type=style&index=0&id=4cf33cbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf33cbe",
  null
  
)

export default component.exports